import { createIcon } from '../icon'
import JacketIcon from '../svg/JacketIcon'

export const JacketIconDefault = createIcon(JacketIcon)
